module.exports = new __parcel__URL__("defense_log_tab_inactive.085ccd84.png").toString();